import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var WatcherService = /** @class */ (function () {
    function WatcherService(http) {
        this.http = http;
        this._baseUrl = "" + environment.baseUrlWs + environment.wsVerison + "/employer";
    }
    WatcherService.prototype.retrieveOperators = function () {
        var url = this._baseUrl + "/operators";
        return this.http.get(url);
    };
    WatcherService.prototype.deleteWatcher = function (jobOfferId) {
        var url = this._baseUrl + "/jobs/" + jobOfferId + "/watchers/";
        return this.http.delete(url);
    };
    WatcherService.prototype.setWatcher = function (jobOfferId, operatorid) {
        var url = this._baseUrl + "/jobs/" + jobOfferId + "/watchers/" + operatorid;
        return this.http.post(url, null);
    };
    WatcherService.ngInjectableDef = i0.defineInjectable({ factory: function WatcherService_Factory() { return new WatcherService(i0.inject(i1.HttpClient)); }, token: WatcherService, providedIn: "root" });
    return WatcherService;
}());
export { WatcherService };
